import React from 'react';
import { IconProps } from '../IconProps';
const SvgNova = ({
  primaryColor = '#FFCF26',
  secondaryColor = '#F0A378',
  tertiaryColor = '#2D150D',
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
    <circle
      cx={12}
      cy={12}
      r={12}
      fill="url(#Nova_svg__paint0_radial_944_11328)"
    />
    <defs>
      <radialGradient
        id="Nova_svg__paint0_radial_944_11328"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0 22.0831 -28.1813 0 12 11.966)"
      >
        <stop offset={0.11} stopColor={primaryColor} />
        <stop offset={0.61} stopColor={secondaryColor} />
        <stop offset={1} stopColor={tertiaryColor} />
      </radialGradient>
    </defs>
  </svg>
);
export default SvgNova;
